import { addNotification } from "root/actions";
import notifications, { NOTIFICATION_IDS } from "root/data/NotificationsData";
import { selectCloudName } from "root/selectors";

import getIStock from "../service";
import { MAIN_PAGE_SEARCH_PARAMS, INVALID_TOKEN_CODE } from "../data/consts";
import { selectDownloadedAssets } from "../selectors";
import { types } from "./";


export const retrieveAssets = async (payload, dispatch: Function, getState: Function, dispatcher: Function) => {
	const state = getState();
	const service = getIStock();
	const cloudName = selectCloudName(state);
	const { downloads } = selectDownloadedAssets(state);
	const currentPage = state.istock.list.page;
	const newPage = payload.page || 1;
	const searchParams = {
		searchPhrase: state.istock.searchPhrase,
		mediaType: state.istock.mediaType,
		sortOrder: state.istock.sortOrder,
		...payload,
		filters: {
			...state.istock.filters,
			...payload.filters
		}
	};

	dispatcher(types.SET_RESULTS_RETRIEVE_START);
	dispatcher(types.SET_SEARCH_PARAMS, payload);
	
	const page = newPage > currentPage ? newPage : 1;
	if (page === 1) {
		dispatcher(types.CLEAR_RESULTS);
	}
	
	const results = await service.getSearchResults(cloudName, searchParams, page, downloads);

	if (results?.error) {
		if (results.code === INVALID_TOKEN_CODE) {
			service.logout(cloudName);
			dispatcher(types.SET_USER_LOGOUT_SUCCESS);
			addNotification(notifications[NOTIFICATION_IDS.SERVICE_LOGGED_OUT], dispatch);
		}
		else {
			addNotification(notifications[NOTIFICATION_IDS.ERROR], dispatch);
		}
	}
	else {
		dispatcher(types.SET_RESULTS_RETRIEVE_SUCCESS, results);
	}
	dispatcher(types.SET_RESULTS_RETRIEVE_END);
};

export const retrieveHomePageAssets = async ( dispatch: Function, getState: Function, dispatcher: Function) => {
	const state = getState();
	const service = getIStock();
	const cloudName = selectCloudName(state);
	const { downloads } = selectDownloadedAssets(state);
	const searchParams = MAIN_PAGE_SEARCH_PARAMS;
	dispatcher(types.SET_RESULTS_RETRIEVE_START);

	const results = await service.getSearchResults(cloudName, searchParams, 1, downloads);
	if (results?.error) {
		if (results.code === INVALID_TOKEN_CODE) {
			service.logout(cloudName);
			dispatcher(types.SET_USER_LOGOUT_SUCCESS);
			addNotification(notifications[NOTIFICATION_IDS.SERVICE_LOGGED_OUT], dispatch);
		}
		else {
			addNotification(notifications[NOTIFICATION_IDS.ERROR], dispatch);
		}
	}
	else {
		dispatcher(types.SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS, results);
	}
	dispatcher(types.SET_RESULTS_RETRIEVE_END);
};

export const retrieveProducts = async (dispatch: Function, getState: Function, dispatcher: Function) => {
	const service = getIStock();
	const state = getState();
	const cloudName = selectCloudName(state);
	const result = await service.retrieveProducts(cloudName);
	if (!result?.error) {
		dispatcher(types.RETRIEVE_PRODUCTS_SUCCESS, result);
	}
};
export const retrieveDownloads = async (dispatch: Function, getState: Function, dispatcher: Function) => {
	const service = getIStock();
	const state = getState();
	const cloudName = selectCloudName(state);
	const result = await service.retrieveDownloads(cloudName);
	if (!result?.error) {
		dispatcher(types.RETRIEVE_DOWNLOADS_SUCCESS, result);
	}
};

export const getAccountInfo = async (dispatch: Function, getState: Function, dispatcher: Function) => {
	const service = getIStock();
	const state = getState();
	const cloudName = selectCloudName(state);
	const result = await service.getAccountInfo(cloudName);

	if (!result?.error) {
		dispatcher(types.RETRIEVE_ACCOUNT_INFO_SUCCESS, result);
	}
};
